import React, { useState } from "react";
import jsQR, { QRCode } from "jsqr";
import WebcamCapture from "../web-cam-capture";

const QRScanner = ({ getCode }: { getCode: Function }) => {
  const [code, setCode] = useState<QRCode>();
  const handleScan = (imageSrc: any) => {
    if (imageSrc) {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);
        const imageData: any = ctx?.getImageData(
          0,
          0,
          canvas.width,
          canvas.height
        );
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: "dontInvert",
        });
        if (code) {
          getCode(code);
          setCode(code);
          console.log("code: ", code);
        }
      };
    }
  };

  return (
    <div>
      <WebcamCapture onScan={handleScan} />
    </div>
  );
};

export default QRScanner;
